import React from 'react';
import { Button, makeStyles, Paper, Typography } from "@material-ui/core";

import PaymentMethod from '../../../entities/PaymentMethod';
import MakerSubscription, { MakerSubscriptionStatus } from '../../../entities/MakerSubscription';
import { useIsMobile } from '../../../components/Mui3WidthProvider';
import { useAuthenticatedUser } from '../../../utilities/useAuthenticatedUser';

const useStyles = makeStyles((theme) => ({
    section: {
        margin: '0 auto',
        marginTop: theme.spacing(4),
        [theme.breakpoints.up("sm")]: {
            width: "60%",
            marginBottom: theme.spacing(6),
            padding: theme.spacing(4),
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            marginBottom: 30,
            marginTop: 10,
        },
    },
    cancelButton: {
        marginTop: 20,
        color: "#ea1818"
    },
}));

interface Props {
    paymentMethod?: PaymentMethod;
    openUpdateCardDialog: () => void;
    openChangeCardDialog: () => void;
    openCancelDialog: () => void;
    openCancelAndRefundDialog: () => void;
}

export function SubscriptionInfo(props:Props) {
    const { paymentMethod, openCancelAndRefundDialog, openCancelDialog, openChangeCardDialog, openUpdateCardDialog } = props;
    const classes = useStyles();
    const isMobile = useIsMobile();
    const user = useAuthenticatedUser();
    const { makerSubscription, inAdminImpersonationMode } = user;

    const getSubscriptionStatus = (makerSubscription: MakerSubscription) => {
        if (makerSubscription.cancellationDate) {
            return `Cancels on ${new Date(makerSubscription.cancellationDate).toLocaleDateString()}`;
        }

        return MakerSubscriptionStatus[makerSubscription.status];
    }

    return (
        <>
        {!makerSubscription
            && 
            <>
                {isMobile && <Typography style={{ marginTop: 8 }} variant="h5">Free Sermon Maker Subscription</Typography>}
                <Paper className={classes.section} elevation={2}>
                    {!isMobile && <Typography variant="h5">Free Sermon Maker Subscription</Typography>}
                    <Button
                        onClick={() =>  window.location.assign("https://www.sermonmaker.net/upgrade-now/?upgradePath=settings")}
                        color="primary"
                        style={{ marginTop: 20, paddingLeft: isMobile ? 0 : undefined }}
                    >
                        Upgrade
                    </Button>
                </Paper>
            </>
        }
        { makerSubscription
            &&
            <>
            { isMobile && <Typography style={{ marginTop: 8 }} variant="h5">Standard Sermon Maker Subscription</Typography>}
            <Paper className={classes.section} elevation={2}>
                { !isMobile && <Typography variant="h5">Standard Sermon Maker Subscription</Typography>}
                <Typography>Status: {getSubscriptionStatus(makerSubscription)}</Typography>
                {
                    !makerSubscription.cancellationDate
                    &&
                    makerSubscription.serviceStopDate
                    &&
                    <Typography>Renews: {new Date(makerSubscription.serviceStopDate).toLocaleDateString()}</Typography>
                }
                {
                    paymentMethod
                    &&
                    makerSubscription.cancellationDate == null
                    &&
                    <Typography>
                        {
                            `Paid with ${paymentMethod.cardBrand} ending in ${paymentMethod.lastFourOfCardNumber} (Expires ${paymentMethod.expirationMonth}/${paymentMethod.expirationYear}) `
                        }
                        - <a href="UpdateCard" onClick={(e) => {e.preventDefault(); openUpdateCardDialog()}}>Update</a>{" / "}
                        <a href="ChargeCard" onClick={(e) => {e.preventDefault(); openChangeCardDialog()}}>Change</a>
                    </Typography>
                }
                {
                    (makerSubscription.cancellationDate == null || (makerSubscription.currentPlanName === "Standard" || makerSubscription.currentPlanName === "Standard - Discount"))
                    &&
                    <Button
                        className={classes.cancelButton}
                        onClick={openCancelDialog}
                    >
                        Cancel Subscription
                    </Button>
                }
                {
                    inAdminImpersonationMode
                    &&
                    <Button
                        className={classes.cancelButton}
                        onClick={openCancelAndRefundDialog}
                    >
                        Cancel and Refund Subscription
                    </Button>
                }
            </Paper>
            </>
        }
    </>
    )
}